import { FunctionComponent, useState } from 'react';
import { useMedia } from 'react-use';

import { media } from '@savgroup-front-common/constants';
import { Collapse } from '@savgroup-front-common/core/atoms/Collapse';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Field } from '@savgroup-front-common/core/molecules/Field';
import { Divider } from '@savgroup-front-common/core/protons/Divider/Divider';
import { DENSITY } from '@savgroup-front-common/core/protons/Divider/Divider.types';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@savgroup-front-common/core/protons/icons';
import { CustomerFileSummary } from '@savgroup-front-common/types';

import messages from './messages';
import { useTrackingInfo } from './TrackingInfo.hooks';
import {
  $CollapsableButton,
  $FileHeader,
  $Header,
  $TrackingLink,
} from './TrackingInfo.styles';

interface TrackingInfoProps {
  fileInfo: CustomerFileSummary;
}

const TrackingInfo: FunctionComponent<TrackingInfoProps> = ({ fileInfo }) => {
  const [isOpen, setIsOpen] = useState(true);
  const isMobileView = useMedia(media.maxWidth.sm);
  const { trackingNumber, trackingUrl, hasTrackingUrl } = useTrackingInfo({
    fileInfo,
  });

  if (!trackingNumber) {
    return null;
  }

  return (
    <div>
      <$Header>
        <$FileHeader>
          <SafeFormattedMessageWithoutSpread
            message={messages.trackingInfoTitle}
          />
        </$FileHeader>
        <$CollapsableButton onClick={() => setIsOpen(!isOpen)}>
          {isOpen && <ChevronUpIcon />}
          {!isOpen && <ChevronDownIcon />}
        </$CollapsableButton>
      </$Header>

      <Divider density={DENSITY.COMFORTABLE} />

      <Collapse isOpen={isOpen} couldUnmountIfClosed={true}>
        <Field
          label={messages.trackingNumberLabel}
          isHorizontal={!isMobileView}
        >
          {hasTrackingUrl ? (
            <$TrackingLink
              href={trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {trackingNumber}
            </$TrackingLink>
          ) : (
            trackingNumber
          )}
        </Field>
      </Collapse>
    </div>
  );
};

export default TrackingInfo;
